import { IAuctionState, IAuctionStrategy } from '../../types/reducers/auction';

export const defaultStrategy: IAuctionStrategy = {
  isEnabled: false,
  serviceTypes: [],
  strategyName: '',
};

export const auctionDefaultState: IAuctionState = {
  isEnabled: false,
  isBetChanged: false,
  currentOverPackageBet: 0,
  currentOverServiceBet: 0,
  minimalBet: 0,
  maximalBet: 0,
  nextBets: [],
  previousBets: [],
  configurations: {},
  incompatibleServices: [],
  period: null,
  serviceCosts: [],
  strategy: defaultStrategy,
};
